import { render, staticRenderFns } from "./identitySetting.vue?vue&type=template&id=0ad52f71&scoped=true"
import script from "./identitySetting.vue?vue&type=script&lang=js"
export * from "./identitySetting.vue?vue&type=script&lang=js"
import style0 from "./identitySetting.vue?vue&type=style&index=0&id=0ad52f71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad52f71",
  null
  
)

export default component.exports